{
  "byline": {
    "by": "Par {{authors}}",
    "coAuthored": "Coécrit avec {{authors}}",
    "and": "et"
  },
  "meta": {
    "readTime_one": "{{count}} min de lecture",
    "readTime_other": "{{count}} min de lecture",
    "published": "Publié le {{date}}",
    "updated": "Mis à jour le {{date}}",
    "category": "Catégorie"
  },
  "donation": {
    "title": "Soutenez le journalisme indépendant",
    "description": "Votre contribution nous aide à poursuivre nos enquêtes.",
    "cta": "Faire un don",
    "coffeeTitle": "Offrez-nous un café",
    "coffeeText": "Un moyen simple de soutenir nos enquêtes : offrez-nous un café sur Buy Me a Coffee. Chaque tasse compte.",
    "coffeeCta": "Soutenir sur Buy Me a Coffee"
  },
  "share": {
    "title": "Partager cet article",
    "copyLink": "Copier le lien",
    "copied": "Lien copié !",
    "twitter": "Partager sur Twitter",
    "facebook": "Partager sur Facebook"
  },
  "related": {
    "title": "Articles similaires"
  },
  "translation": {
    "availableIn": "Également disponible en",
    "pending": "Traduction en cours"
  },
  "author": {
    "articlesHeader": "Articles de {{name}}",
    "noArticles": "Aucun article publié pour le moment.",
    "articlesCount": "Articles",
    "avgReadTime": "moy."
  },
  "search": {
    "hint": "Recherchez parmi tous les articles publiés, en français, en anglais et en arabe.",
    "resultsCount_one": "{{count}} résultat pour \"{{query}}\"",
    "resultsCount_other": "{{count}} résultats pour \"{{query}}\"",
    "noResults": "Aucun résultat pour \"{{query}}\""
  }
}
